import { ChangeEvent, ReactElement, useState } from 'react';
import { RegisterStep1 } from 'components/Registration/RegisterStep1';
import { RegisterStep2 } from 'components/Registration/RegisterStep2';
import { RegisterStep3 } from 'components/Registration/RegisterStep3';

export type RegistrationFields = {
  email: string;
  password: string;
  firstName: string;
  lastName: string;
  acceptedTerms: boolean;
  marketingEmailOptIn: boolean;
};

export type RegisterStepProps = {
  nextStep: () => void;
  prevStep: () => void;
  handleChanges: (fieldName: string) => (event: ChangeEvent<HTMLInputElement>) => void;
  handleCheckboxChange: (fieldName: keyof RegistrationFields) => (checked: boolean) => void;
  values: RegistrationFields;
};

export const Registration = (): ReactElement => {
  const [step, setStep] = useState(1);
  const [values, setValues] = useState({
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    acceptedTerms: false,
    marketingEmailOptIn: false,
  } as RegistrationFields);

  const prevStep = (): void => {
    setStep(step - 1);
  };

  const nextStep = (): void => {
    setStep(step + 1);
  };

  const handleChanges = (fieldName: string) => (e: ChangeEvent<HTMLInputElement>) => {
    setValues((prevValues) => ({ ...prevValues, [fieldName]: e.target.value }));
  };

  const handleCheckboxChange = (fieldName: keyof RegistrationFields) => (checked: boolean) => {
    setValues((prevValues) => ({ ...prevValues, [fieldName]: checked }));
  };

  switch (step) {
    case 1:
      return (
        <RegisterStep1
          nextStep={nextStep}
          prevStep={prevStep}
          handleChanges={handleChanges}
          handleCheckboxChange={handleCheckboxChange}
          values={values}
        />
      );
    case 2:
      return (
        <RegisterStep2
          nextStep={nextStep}
          prevStep={prevStep}
          handleChanges={handleChanges}
          handleCheckboxChange={handleCheckboxChange}
          values={values}
        />
      );
    case 3:
      return (
        <RegisterStep3
          nextStep={nextStep}
          prevStep={prevStep}
          handleChanges={handleChanges}
          handleCheckboxChange={handleCheckboxChange}
          values={values}
        />
      );
    default:
      return (
        <RegisterStep1
          prevStep={prevStep}
          nextStep={nextStep}
          handleChanges={handleChanges}
          handleCheckboxChange={handleCheckboxChange}
          values={values}
        />
      );
  }
};
